import React from 'react';
import PropTypes from 'prop-types';

function Image(props) {
  const { alt, src, ...others } = props;

  return (
    <img
      loading='lazy'
      {...others}
      src={src}
      alt={alt}
    />
  );
}

Image.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
};

Image.defaultProps = {
  alt: '',
};

export default Image;
